import React, { Component } from 'react'
import { connect } from 'react-redux'
import { evaluTestActions } from '../../../../actions'
import { Translate } from '../../../../utils'
import { ButtonCLick, ContainerPages, Loader, RefreshSvg } from '../../../_Common'
import { LabelTest } from './utils'
import PropTypes from "prop-types";
import {
    addUrlProps,
    UrlQueryParamTypes
} from "react-url-query";
import { DetailJta } from './DetailJta'
const urlPropsQueryConfig = {
    currentTab: { type: UrlQueryParamTypes.string },
    tab: { type: UrlQueryParamTypes.string },
    viewJta: { type: UrlQueryParamTypes.string },
};
class EvaluationTestEnd extends Component {
    constructor(props) {
        super(props)
        this.state = {
            datagrille: [{ titleGrile: "Grile pour la list de test", lables: "", date: new Date(), firstName: "Zino", lastName: "Khedri", idgrille: "1548" }]
        }
        this.handleRefresh = this.handleRefresh.bind(this)
        this.handleJta = this.handleJta.bind(this)
        if (props.getTest !== "1") {
            props.getJta()
        }
    }
    static defaultProps = {
        currentTab: 'candidate',
        tab: null,
        viewJta: null,
    }
    static propTypes = {
        currentTab: PropTypes.string,
        tab: PropTypes.string,
        viewJta: PropTypes.string,
        /********************** */
        onChangeCurrentTab: PropTypes.func,
        onChangeTab: PropTypes.func,
        onChangeViewJta: PropTypes.func,
    };
    componentDidMount() {
        document.title = Translate('titles', 'app') + " - Historique"
    }
    componentWillReceiveProps(nextProps) {
        const { handleTest, datahandleTest, getJta } = nextProps
        if (this.props.handleTest === "0" && handleTest === "1" && datahandleTest) {
            getJta()
        }
    }
    handleJta(action, test) {
        switch (action) {
            case 'detail':
                this.props.onChangeViewJta(test)
                break;
            case 'edit':
                this.props.onChangeTab(test)
                break;
            case 'delete':
                this.props.DeleteJta(test)
                break;
            default:
                let update = {
                    jta_evaluation_id: test,
                    status: action
                }
                this.props.handleJta(update)
                break;
        }
    }
    handleRefresh() {
        this.props.getJta()
    }
    render() {
        const { getTest, dataGetTest, handleTest, viewJta } = this.props
        var end = []
        if (getTest === "1" && dataGetTest && dataGetTest.jtas) {
            end = Array.isArray(dataGetTest.jtas.end) ? dataGetTest.jtas.end : []
        }
        return (
            <ContainerPages titlePage={'Historique'} contentLeft={<div className="dis-flex">
                <ButtonCLick TextBottun={RefreshSvg} action={this.handleRefresh} />
            </div>}>
                {(getTest === "0" || handleTest === "0") && <Loader style={{ minHeight: "300px" }} />}
                <div>
                    {end.length > 0 && <LabelTest histo={true} handleJta={this.handleJta} bdg_st="bdg-valid" TestStatus="terminé" className="topM-15" textLabel={Translate('test', 'tremtest')} testList={end} />}
                </div>
                {viewJta && <DetailJta isActive={viewJta} Close={this.props.onChangeViewJta} />}
            </ContainerPages>
        )
    }
}
function mapState(state) {
    const { getTest, dataGetTest, handleTest, datahandleTest } = state.evaluTest
    return { getTest, dataGetTest, handleTest, datahandleTest }
}
const actionsClass = {
    getJta: evaluTestActions.getJta,
    DeleteJta: evaluTestActions.DeleteJta,
    handleJta: evaluTestActions.handleJta
}
const connectedClass = connect(mapState, actionsClass)(EvaluationTestEnd);
const QueryProps = addUrlProps({ urlPropsQueryConfig })(connectedClass)
export { QueryProps as EvaluationTestEnd };